import React from 'react';
import { CTAButton } from './CTAButton';
import { Star, Shield, Zap } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-10 px-4 bg-brand-petrol text-white" data-id="element-62">
      <div className="max-w-3xl mx-auto text-center" data-id="element-63">
        <p className="text-sm font-bold text-brand-gold uppercase tracking-wide mb-3" data-id="element-64">
          ONE LAST CHANCE
        </p>

        <p className="text-base sm:text-lg mb-5 leading-relaxed" data-id="element-65">
          Your clients deserve the best version of you — not an exhausted one.
          Stop spending your Sundays programming. Take back control of your
          coaching career with professional tools built for real results.
        </p>

        <div className="bg-white/10 border-2 border-white/20 rounded-xl p-5 mb-6" data-id="element-66">
          <p className="text-base mb-2" data-id="element-67">
            FUNCTIONAL PRO™ 6-in-1 Complete System + 5 Professional Bonuses
          </p>
          <p className="text-xl line-through opacity-70 mb-1" data-id="element-68">$97 USD</p>
          <p className="text-4xl font-serif font-bold" data-id="element-69">Only: $27 USD</p>
        </div>

        <CTAButton href="https://functionalpro.impultienda.ar/checkout" className="max-w-md mx-auto !bg-brand-gold !text-brand-graphite !border-white text-base sm:text-lg py-4 shadow-2xl ring-4 ring-brand-gold/40 hover:!bg-white hover:!text-brand-petrol hover:scale-[1.02]" data-id="element-70">
          🚀 YES, I WANT MY FUNCTIONAL PRO™ SYSTEM
        </CTAButton>

        <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-2 text-sm mt-5 opacity-90" data-id="element-71">
          <div className="flex items-center gap-1" data-id="element-72">
            <Zap className="w-4 h-4" data-id="element-73" />
            <span data-id="element-74">Immediate Access — Delivered Instantly by Email</span>
          </div>
          <span className="hidden sm:inline" data-id="element-75">•</span>
          <div className="flex items-center gap-1" data-id="element-76">
            <Star className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-77" />
            <span data-id="element-78">4.9/5 — Verified Professional Reviews</span>
          </div>
          <span className="hidden sm:inline" data-id="element-79">•</span>
          <div className="flex items-center gap-1" data-id="element-80">
            <Shield className="w-4 h-4" data-id="element-81" />
            <span data-id="element-82">7-Day Guarantee — Zero Risk</span>
          </div>
        </div>
      </div>
    </section>;
}